import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect,withRouter } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import RouteInterceptor from '../privateRoute/RouterInterceptor'
import Profile from './profile/index'
import Dashboard from './dashboard/index'
import { connect } from "react-redux";
import NotFound from "views/error-pages/NotFound";
import VerifyEmail from "./profile/verifyEmail";
import EditBasic from "./profile/EditBasic";
import EditAddress from "./profile/EditAddress";
import EditExperience from "./profile/EditExperience";
import EditEducation from "./profile/EditEducation";
import ChangePasswordForm from "./profile/ChangePasswordForm";
import EditHobbies from "./profile/EditHobbies";
import EditSkills from "./profile/EditSkills";
import EditCoverletter from "./profile/EditCoverletter";
const AppViews = ({token}) => {
  return (
    <Suspense fallback={<Loading cover="content"/>}>
      <Switch>
       
        <Route path={`${APP_PREFIX_PATH}/home`} component={lazy(() => import(`./jobrole`))} />
        <Route path={`${APP_PREFIX_PATH}/support`} component={lazy(() => import(`./profile/Support`))} />
        <Route path={`${APP_PREFIX_PATH}/privacy-policy`} component={lazy(() => import(`./privacy`))} />
        <Route path={`${APP_PREFIX_PATH}/terms-conditions`} component={lazy(() => import(`./terms-conditions`))} />
        <RouteInterceptor path={`${APP_PREFIX_PATH}/profile/edit/`} isAuthenticated={token}>
          <Profile/>
        </RouteInterceptor>

        <RouteInterceptor path={`${APP_PREFIX_PATH}/profile/edit-basic`} isAuthenticated={token}>
          <EditBasic/>
        </RouteInterceptor>
        <RouteInterceptor path={`${APP_PREFIX_PATH}/profile/edit-address`} isAuthenticated={token}>
          <EditAddress/>
        </RouteInterceptor>
        <RouteInterceptor path={`${APP_PREFIX_PATH}/profile/edit-experience`} isAuthenticated={token}>
          <EditExperience/>
        </RouteInterceptor>
        <RouteInterceptor path={`${APP_PREFIX_PATH}/profile/edit-education`} isAuthenticated={token}>
          <EditEducation/>
        </RouteInterceptor>
        <RouteInterceptor path={`${APP_PREFIX_PATH}/profile/change-pass`} isAuthenticated={token}>
          <ChangePasswordForm/>
        </RouteInterceptor>

        <RouteInterceptor path={`${APP_PREFIX_PATH}/profile/edit-hobbies`} isAuthenticated={token}>
          <EditHobbies/>
        </RouteInterceptor>
        <RouteInterceptor path={`${APP_PREFIX_PATH}/profile/edit-skills`} isAuthenticated={token}>
          <EditSkills/>
        </RouteInterceptor>
        <RouteInterceptor path={`${APP_PREFIX_PATH}/profile/edit-coverletter`} isAuthenticated={token}>
          <EditCoverletter/>
        </RouteInterceptor>

        <RouteInterceptor path={`${APP_PREFIX_PATH}/profile/verify-email/:token`} isAuthenticated={token}>
          <VerifyEmail />
        </RouteInterceptor>
        <RouteInterceptor path={`${APP_PREFIX_PATH}/dashboard`} isAuthenticated={token}>
          <Dashboard />
        </RouteInterceptor>
        <Route>
          <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/home`} />  
        </Route>
        {/* <Route path="*">
          <NotFound/>
        </Route> */}
      </Switch>
    </Suspense>
  )
}

const mapStateToProps = ({  auth }) => {

	const { token } = auth;
	return { token}
  };

export default  withRouter(connect(mapStateToProps)(AppViews));